import React, { Fragment } from 'react';

import { Col, Container, Row } from 'reactstrap';
import BuildingsMatTable from './components/BuildingsMatTable';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { withRouter } from 'react-router-dom';
import TrialAlert from '../../shared/components/payment/TrialAlert';

import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission	} from "../../shared/helpers/access";

import {
  isMobile,
} from "react-device-detect";

const SEGMENT_TITLES = {
	condos: 'Condos & Co-ops',
	rental: 'Rental Buildings',
	commercial: 'Commercial Buildings',
	'multi-family': 'Multi-Family Buildings',
	'vacant-land': 'Vacant Land',
	other: 'All Buildings',
};

const SEGMENT_SUBHEADS = {
	condos: 'Search for Condo and Co-op Buildings by Location, Status, Price and More.',
	rental: 'Search for Rental and Apartment Buildings by Location, Size and More.',
	commercial: 'Search for Commercial Buildings by Location, Size, Type and More.',
	'multi-family': 'Search for Multi-Family Buildings by Location, Size, Price and More.',
	'vacant-land': 'Search for Vacant Lots and Land by Location, Size, Zoning and More.',
	other: 'Search All Buildings by Type, Location, Size, Price and More.',
};

const BuildingsUnified = ( {user, match } ) => {
	const segment = match && match.params && match.params.segment ? match.params.segment : 'condos';
	const title = SEGMENT_TITLES[segment] || SEGMENT_TITLES['other'];
	const subhead = SEGMENT_SUBHEADS[segment] || SEGMENT_SUBHEADS['other'];

	return(
		<Container>
			<Row>
				<Col md={12}>
					<h3 className="page-title">{title}</h3>
					{!isMobile && <h3 className="page-subhead subhead">{subhead}</h3> }
				</Col>
			</Row>
			{_hasPermission(user, 'building-search') ?
				<Fragment>
					<Row>
						<Col md={12} className={'mb-3'}>
							<TrialAlert />
						</Col>
					</Row>
					<Row>
						<BuildingsMatTable segment={segment} />
					</Row>
				</Fragment>
				:
				<Row>
					<EnterpriseGate />
				</Row>
			}
		</Container>
	)
};


export default connect(state => ({
  user: state.user,
}))(withOktaAuth(withRouter(BuildingsUnified)));
